// src/components/copilot/blocks/BlockRenderer.js
import TextBlock from "./TextBlock";
import TableBlock from "./TableBlock";
import ChartBlock from "./ChartBlock";
import CitationsBlock from "./CitationsBlock";
import ClarificationBlock from "./ClarificationBlock";

export default function BlockRenderer({ blocks = [], onCitationClick, onClarify }) {
  return (
    <div className="flex flex-col gap-4">
      {blocks.map((block, i) => {
        switch (block.type) {
          case "text":          return <TextBlock key={i} block={block} />;
          case "table":         return <TableBlock key={i} block={block} />;
          case "chart":         return <ChartBlock key={i} block={block} />;
          case "citations":     return <CitationsBlock key={i} block={block} onCitationClick={onCitationClick} />;
          case "clarification": return <ClarificationBlock key={i} block={block} onClarify={onClarify} />;
          default:              return null;
        }
      })}
    </div>
  );
}
